import React, { useRef, useEffect, useState } from 'react'
import { buildFileUrl } from '../../config/strapi'


interface FourthCardProps {
  card: any
}

export function FourthCard({ card }: FourthCardProps) {
  const listRef = useRef<HTMLDivElement>(null)
  const [imgHeight, setImgHeight] = useState<number | undefined>(undefined)

  useEffect(() => {
    if (listRef.current) {
      setImgHeight(listRef.current.offsetHeight)
    }
  }, [card])

  if (!card) return null

  const title = card.title
  const list = Array.isArray(card.list) ? card.list : []
  const imageUrl = card.image?.url
    ? buildFileUrl(card.image.url)
    : card.background?.url
    ? buildFileUrl(card.background.url)
    : undefined

  return (
    <section
      style={{
        width: '100%',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'clamp(40px, 8vw, 80px) clamp(12px, 4vw, 32px) 0',
        minHeight: 'clamp(340px, 55vh, 520px)',
        boxSizing: 'border-box',
        fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }}
    >
      <div
        className="fourth-card-row"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: 1330,
          gap: 'clamp(32px, 8vw, 150px)',
          position: 'relative',
          flexWrap: 'wrap',
          marginBottom: '4vw'
        }}
      >
        {/* Imagem à esquerda com título sobreposto */}
        <div style={{ position: 'relative', width: 'clamp(220px, 30vw, 400px)', minWidth: 220, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '0 auto' }}>
          {/* Imagem */}
          {imageUrl && (
            <img
              src={imageUrl}
              alt={title || 'Imagem demonstrativa'}
              style={{
                width: 'clamp(220px, 30vw, 400px)',
                minWidth: 180,
                height: imgHeight || 320,
                maxHeight: 540,
                borderRadius: 12,
                boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
                marginTop: 0,
                objectFit: 'cover',
                background: '#f5f5f5',
                display: 'block',
                marginLeft: 0,
                marginRight: 0,
              }}
            />
          )}
          {/* Título sobreposto por cima da imagem */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: '-32px',
            background: '#0072c6',
            color: 'white',
            fontWeight: 700,
            fontSize: 'clamp(18px, 3vw, 28px)',
            padding: 'clamp(10px, 2vw, 16px) clamp(20px, 4vw, 40px) clamp(10px, 2vw, 16px) clamp(12px, 2vw, 24px)',
            borderRadius: '12px 0 24px 0',
            zIndex: 2,
            boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
            letterSpacing: 1,
            transform: 'translateY(-30%)',
            minWidth: 120,
            maxWidth: '90vw',
            textAlign: 'left',
            wordBreak: 'break-word',
          }}>
            {title}
          </div>
        </div>
        {/* Lista à direita */}
        <div ref={listRef} style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 'clamp(10px, 2vw, 20px)', minWidth: 220, paddingLeft: 'clamp(0px, 6vw, 100px)', maxWidth: 700, margin: '0 auto' }}>
          {list.map((item: any, idx: number) => (
            <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 8 }}>
              {/* Reason: Bolinha alinhada com a primeira linha do texto usando mesma lineHeight e height */}
              <span style={{ 
                color: '#111', 
                fontSize: 'clamp(22px, 4vw, 32px)', 
                lineHeight: 1.4, 
                flexShrink: 0,
                height: 'calc(clamp(15px, 2vw, 22px) * 1.4)',  // Altura da primeira linha do texto
                display: 'flex',
                alignItems: 'center'
              }}>•</span>
              <span style={{ fontSize: 'clamp(15px, 2vw, 22px)', color: '#222', lineHeight: 1.4, letterSpacing: 1, textAlign: 'left', wordBreak: 'break-word' }}>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .fourth-card-row {
            flex-direction: column !important;
            gap: clamp(24px, 6vw, 48px) !important;
            align-items: center !important;
          }
        }
        @media (max-width: 600px) {
          .fourth-card-row {
            gap: clamp(16px, 4vw, 32px) !important;
          }
        }
      `}</style>
    </section>
  )
} 